import React, { memo, ReactNode } from 'react';
import { css, ClassNames } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { CssProp, Theme } from '@core/utils/css';
import { useModalInstance } from '@core/components/ModalStack';
import { Icon } from '@mui/material';
import { R } from '@core/utils/r';
import { DialogTitle, IconButton } from '@mui/material';

const styles = {
  container: css`
    // padding: 0 !important;
    border-bottom: 2px solid #556ee625;
    // margin-bottom: 16px;
    background-color: ${Theme.isDark ? Theme.modalBackgroundColor : '#FFF'};

    height: 65px;
    padding: 0px 10px 0px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    letter-spacing: inherit;

    .modal_title {
      flex: 1;
      font-family: 'Poppins', sans-serif;
      color: ${Theme.modalTextColor};
      font-size: 16px;
      font-weight: 600;
      line-height: 1;
      letter-spacing: inherit;
      top: auto;
    }
  `,

  noBorder: css`
    border-bottom: none;
  `,

  customContent: css`
    .MuiTypography-root {
      height: auto;
      align-items: flex-start;
      position: relative;
    }
  `,
};

export interface ModalHeaderProps {
  customCss?: CssProp;
  closeButton?: boolean;
  titleCss?: CssProp;
  titleStyle?: React.CSSProperties;
  title?: ReactNode;
  children?: ReactNode;
  noBorder?: boolean;
  onClose?(): void | boolean;
  onMinimize?(): void;
  noClose?: boolean;
  rightContent?: ReactNode;
}

export const ModalHeader = memo((props: ModalHeaderProps) => {
  const modal = useModalInstance();

  const closeButton = props.closeButton !== false && (
    <IconButton
      className="close_button"
      size="medium"
      onClick={() => {
        const result = props.onClose && props.onClose();
        if (R.isBoolean(result) && result === false) {
          return;
        }

        modal.close();
      }}
    >
      <CloseIcon />
    </IconButton>
  );

  const minimizeButton = props.closeButton !== false && (
    <IconButton className="close_button" size="medium" onClick={props.onMinimize}>
      <Icon className="fa fa-minus" />
    </IconButton>
  );

  return (
    <ClassNames>
      {({ css }) => (
        <DialogTitle
          classes={{
            root: css([styles.container, !!props.children && styles.customContent, props.noBorder && styles.noBorder, props.customCss]),
          }}
        >
          <span className="modal_title" css={props.titleCss} style={props.titleStyle}>
            {props.title || props.children}
          </span>

          {!!props.onMinimize && minimizeButton}
          {!!props.rightContent && <div style={{ fontSize: 'initial', fontWeight: 'initial' }}>{props.rightContent}</div>}
          {!props.noClose && closeButton}
        </DialogTitle>
      )}
    </ClassNames>
  );
});
